import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './PushPreview.scss';

const PushPreview = ({ push }) => {
  if (!push) return null;

  const hasError = push.error;
  const title = push.title || push.headings?.en || 'Notification';
  const subtitle = push.subtitle || push.contents?.en || '';
  const imageUrl = push.ios_attachments?.id || push.big_picture || null;

  return (
    <div className='push-preview-outer'>
      <div className='iphone-shell'>
        <div className='iphone-bezel'>
          <div className='iphone-screen lock-screen'>
            <div className='status-bar'>
              <span className='status-time'>9:41</span>
              <div className='dynamic-island' />
              <div className='status-icons'>
                <svg className='status-icon' viewBox='0 0 18 12' fill='currentColor'>
                  <rect x='0' y='7' width='3' height='5' rx='0.5' opacity='0.4' />
                  <rect x='4' y='5' width='3' height='7' rx='0.5' opacity='0.6' />
                  <rect x='8' y='3' width='3' height='9' rx='0.5' opacity='0.8' />
                  <rect x='12' y='0' width='3' height='12' rx='0.5' />
                </svg>
                <svg className='status-icon' viewBox='0 0 16 12' fill='currentColor'>
                  <path d='M8 3.6c1.8 0 3.4.7 4.6 1.9l1.1-1.1C12.1 2.8 10.1 2 8 2s-4.1.8-5.7 2.4l1.1 1.1C4.6 4.3 6.2 3.6 8 3.6z' />
                  <path d='M8 6.8c1 0 2 .4 2.8 1.1l1.1-1.1C10.7 5.6 9.4 5.2 8 5.2s-2.7.4-3.9 1.6l1.1 1.1C6 6.9 7 6.8 8 6.8z' />
                  <circle cx='8' cy='10' r='1.5' />
                </svg>
                <div className='battery-icon'>
                  <div className='battery-body'>
                    <div className='battery-fill' />
                  </div>
                  <div className='battery-cap' />
                </div>
              </div>
            </div>

            <div className='lock-content'>
              <div className='lock-time'>9:41</div>
              <div className='lock-date'>Wednesday, March 18</div>
            </div>

            <div className='notification-area'>
              <div className={cn('push-notification', { error: hasError })}>
                {hasError ? (
                  <div className='push-error'>Error: {push.error}</div>
                ) : (
                  <>
                    <div className='push-header'>
                      <div className='app-icon'>S</div>
                      <span className='app-name'>SHOPMY</span>
                      <span className='push-time'>now</span>
                    </div>
                    <div className='push-body'>
                      <div className='push-text'>
                        <div className='push-title'>{title}</div>
                        {subtitle && <div className='push-subtitle'>{subtitle}</div>}
                      </div>
                      {imageUrl && (
                        <div className='push-image'>
                          <img src={imageUrl} alt='' />
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className='home-indicator-area'>
              <div className='home-indicator' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PushPreview.propTypes = {
  push: PropTypes.object
};

export default PushPreview;
